import AddUserForm from "components/addUserForm/AddUserForm";

const AddUserPage = () => {

  return (
    <AddUserForm
      roleName="Firm User"
      returnEndpoint="firm-users"
    />
  )
};

export default AddUserPage;